import { LoadReportModal } from "../components/LoadReportModal";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, KeyValue, SortDirection } from "../interfaces";
import { updateSortOrder } from "../common/actions";

function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(updateSortOrder(sortField, sortDirection));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LoadReportModal);
